import { Injectable } from '@angular/core';

import {BehaviorSubject, Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import Auth from './auth.model';
import {map} from 'rxjs/operators';
import {Router} from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  //private loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private currentUserSubject: BehaviorSubject<Auth>;
  public currentUser: Observable<Auth>;

  constructor(
    private http: HttpClient,
    private router: Router
    ) {
    console.log(localStorage.getItem('user'));
    this.currentUserSubject = new BehaviorSubject<Auth>(this.getUserCurrent());
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): Auth {
    return this.currentUserSubject.value;
  }

  getUserCurrent() {
   // console.log(atob(localStorage.getItem('user')))

    if (localStorage.getItem('user') === null ) {
        return null;
    }
    return JSON.parse(atob(localStorage.getItem('user')));
  }

  logar(auth: Auth): Observable<any> {
    return this.http.post<any>(environment.url_rest + '/nfse/login', auth).pipe(
      map(result => {
        console.table(result);
        if (result.data && result.status == 200) {
         // localStorage.setItem('token', result.dados.token);
          localStorage.setItem('user', btoa(JSON.stringify(result.data)));
          this.currentUserSubject.next(result.data);
        }
        return result;
      })
    );
  }
  logout() {
    localStorage.removeItem('user');
  //  localStorage.removeItem('token');
    this.currentUserSubject.next(false);
    this.router.navigate(['/auth']);
  }
}
